export const dialogDetachPatientModalStyled = {
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: '560px',
    padding: '20px 24px 24px',
    borderRadius: '24px',
  }
}
